import { OptionNum } from '@Components/types/options';

const warrantyYearsTypeOptions: OptionNum[] = [
  { label: '1 year', value: 0 },
  { label: '2 Years', value: 1 },
];

enum WarrantyType {
  STANDART = 1,
  SPECIAL,
  NA,
}

enum CostCenterType {
  Project = 'Project',
  Stock = 'Stock',
  OverHead = 'OverHead',
  Plant = 'Plant',
}

enum ReceiveStoreTypeCodes {
  COST_CENTER_TYPE_OVERHEAD = 3,
  COST_CENTER_TYPE_PLANT = 4,
  COST_CENTER_PLANT = 22,
}

export {
  warrantyYearsTypeOptions,
  WarrantyType,
  CostCenterType,
  ReceiveStoreTypeCodes,
};
